import { IS_PROD } from './env';

export const COMPANY_NAME = IS_PROD
  ? typeof window != 'undefined'
    ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (window as any).company
    : null
  : process.env.NEXT_PUBLIC_COMPANY_NAME;
